var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"subtitle-2 success--text"},[_vm._v(_vm._s(_vm._f("currency")(item.value))+" "+_vm._s(item.currency))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }